// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"style_lds-dual-ring__MLYfv","lds-dual-ring-after":"style_lds-dual-ring-after__Hq6F9"};